import { jsx } from 'react/jsx-runtime';
import { ChevronRightIcon } from '@flex-design-system/legacy-flex-icons';
import { forwardRef } from 'react';
import { DropdownSlot } from '../slot/Slot.mjs';
import { dropdownSubTriggerIndicatorIcon } from './subTriggerIndicator.vanilla.mjs';

const DropdownSubTriggerIndicator = forwardRef((props, forwardedRef) => {
  return /* @__PURE__ */ jsx(
    DropdownSlot,
    {
      "aria-hidden": true,
      "data-scope": "dropdown",
      "data-part": "sub-trigger-indicator",
      ref: forwardedRef,
      ...props,
      children: /* @__PURE__ */ jsx(ChevronRightIcon, { className: dropdownSubTriggerIndicatorIcon })
    }
  );
});

export { DropdownSubTriggerIndicator };
//# sourceMappingURL=SubTriggerIndicator.mjs.map
